<template>
	<div class="answers_block" >
		<div class="button_add mb-4">
			<button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_camera()">
				<span class="fal  fa-eject mr-1"></span>
				Додати
			</button>
		</div>

		<div class="inf answers">
			<b-overlay :show="is_load" rounded="sm">
				<div v-if="items.length > 0">
					<ul style="list-style: none" class="pl-0">
						<li class="mt-2 list-style-none p-4 card" v-for="(item,idx) in items">
							<div class="form-group">
								<div class="input-group">
									<input placeholder="URL camera" type="text" v-model="item.axon_url" class="form-control">

									<div class="input-group-append">
										<div class="input-group-text">
											<div class="custom-control d-flex custom-switch">
												<input :id="'eventlog-switch-' + idx " v-model="item.is_plate" type="checkbox" class="custom-control-input">
												<label class="custom-control-label fw-500" :for="'eventlog-switch-'  + idx">
													Розпізнання *
												</label>
											</div>
										</div>

										<div class="input-group flex-nowrap">
											<b-form-radio-group
												:id="'btn-radios-' + idx"
												class="input-group-text"
												v-model="item.direction"

												:options="[
												  { text: 'IN', value: 'in' },
												  { text: 'OUT', value: 'out' }]"
												:name="'radios-btn-default' + idx"

											></b-form-radio-group>
										</div>

										<button type="button" class="btn btn-outline-danger " v-on:click="remove_camera(idx)">Видалити</button>
									</div>

								</div>
							</div>
						</li>
					</ul>
				</div>
			</b-overlay>
		</div>

	</div>
</template>

<script>
export default {
	name: "camera_list",
	props : {
		question : {
			type : Object
		}
	},

	data () {
		return {
			is_load : false,
		}
	},
	methods : {
		add_camera() {
			this.items.push({
				"id": 0,
				"axon_url": "",
				"direction" : "in",
				"is_plate" : 0,
			})
		},

		remove_camera(idx) {
			console.log("Remove :" + idx);
			this.items.splice(idx,1);
		},
	},

	computed : {
		items : {
			get :  function() {
				if(this.question.hasOwnProperty("cameras")) {
					return this.question.cameras;
				}

				return [];
			},

			set : function(val) {
				this.question.cameras = val;
			}
		},
	},

}
</script>

<style scoped>

</style>
